import TextBase from "../text";
import {convertPxToRem} from "../../helper";
import {Colors} from "../../themes/Colors";
import React from "react";
import PropTypes from "prop-types";

const InputError = (props) => {
    const { error } = props;
    return (
        <TextBase
            style={{textAlign: "left", marginTop: 'var(--sp-xs)'}}
            size={'calc(var(--fs-sm2) * 1.015)'}
            color={Colors.red}
        >
            {error}
        </TextBase>
    )
}

InputError.propTypes = {
    error: PropTypes.string,
};

export default InputError
